import { useCallback, useContext, useSyncExternalStore } from 'react';
import { ReactReduxContext } from 'react-redux';
import { currentFeedbackActor, FeedbackActor } from './feedbackSubmission';

/** Supports both the React store and the legacy-only feedback host. */
export default function useFeedbackActor() {
  const context = useContext(ReactReduxContext);
  const store = context?.store;
  const currentActor = useCallback(() => store
    ? currentFeedbackActor((store.getState() as any)?.user)
    : currentFeedbackActor(), [store]);
  const snapshot = useCallback(() => currentActor()?.key || '', [currentActor]);
  const subscribe = useCallback((notify: () => void) => {
    const unsubscribe = store?.subscribe(notify);
    window.addEventListener('storage', notify);
    window.addEventListener('focus', notify);
    window.addEventListener('pageshow', notify);
    return () => {
      unsubscribe?.();
      window.removeEventListener('storage', notify);
      window.removeEventListener('focus', notify);
      window.removeEventListener('pageshow', notify);
    };
  }, [store]);
  const key = useSyncExternalStore(subscribe, snapshot, snapshot);
  const actor: FeedbackActor | null = key ? { key, hygienistId: Number(key.split(':')[1]) } : null;
  return { actor, currentActor };
}
